import React, { useEffect, useCallback, useMemo } from "react";
import { FormikValues } from "formik";
import ComponentsList, { IComponentList } from "./components-list";

interface ComponentProps {
  value?: any;
  [key: string]: any;
}

interface IProps {
  component: keyof IComponentList | React.ComponentType<ComponentProps>;
  value?: any;
  setData?: (values: FormikValues) => void;
  [key: string]: any;
}

const VALUE_PROP = "value";

const Callinputs: React.FC<IProps> = React.memo(
  ({ component, value, setData, ...rest }) => {
    useEffect(() => {
      if (setData && rest.values) {
        setData(rest.values);
      }
    }, [setData, rest.values]);

    const renderComponent = useCallback(
      (Component: React.ComponentType<ComponentProps>): JSX.Element => {
        const componentProps = Component.defaultProps || {};
        const acceptsValue = VALUE_PROP in componentProps;

        const props = {
          ...rest,
          ...(acceptsValue ? { [VALUE_PROP]: value || "" } : {}),
        };

        return <Component {...props} />;
      },
      [rest, value],
    );

    const Component = useMemo(
      () =>
        typeof component === "string"
          ? ComponentsList[component as keyof IComponentList]
          : component,
      [component],
    );

    if (!Component) return null;

    return renderComponent(Component);
  },
);

export default Callinputs;
